module.exports = __webpack_public_path__ + "img/face15.736ec0d9.jpg";